import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import classNames from 'classnames';
import { getApplicationStatus } from '../../../../api/lendingAPI/ApplicationSelector';

import { AutoAddress } from '../../../../forms/autoAddress';
import { ManualAddress } from '../../../../forms/manualAddress/ManualAddress';
import { supportsAutoAddress } from '../../../../helpers/address';
import { buildAddressLabel } from '../../../../forms/autoAddress/AutoAddressHelper';
import styles from './AddressQuestion.module.css';
import { renderTextInput } from '../../../../forms/formField/Input';
import { RootState } from '@iwProvider/configureStore';
import { TDeserialisedAddresses } from '../PersonModal.types';

const selector = formValueSelector('person');
const mapStateToProps = (state: RootState) => ({
    ...state.personModal,
    hasCreditDecision: getApplicationStatus(state) !== 'open',
    isGuarantor: selector(state, 'isGuarantor'),
    isApplicant: selector(state, 'isApplicant')
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

class AddressQuestion extends Component<
    {
        name: string;
        addressIndex: number;
        onManualAddressToggle: (arg: number) => void;
        fetchedAddresses: TDeserialisedAddresses;
        onChange: (postcode: string) => { type: string; postcode: string };
    } & PropsFromRedux
> {
    renderAddressField = (fieldProps: any) => {
        const {
            showManualAddresses,
            addressIndex,
            onManualAddressToggle,
            addresses
        } = this.props;
        const showManualAddress =
            showManualAddresses?.[addressIndex] || !supportsAutoAddress();
        const disableEditingAdditionalGuarantor =
            this.props.hasCreditDecision &&
            this.props.isEditingPerson &&
            this.props.isGuarantor &&
            !this.props.isApplicant;

        if (disableEditingAdditionalGuarantor) {
            return (
                <div
                    className={classNames(
                        styles.disabled_address_field,
                        'fs-exclude'
                    )}
                >
                    {renderTextInput({
                        input: {
                            value: buildAddressLabel(addresses[addressIndex])
                        },
                        meta: {},
                        disabled: true,
                        'data-testid': 'non-editable-address-input'
                    })}
                </div>
            );
        }

        if (showManualAddress) {
            return (
                <ManualAddress
                    onManualAddressToggle={onManualAddressToggle}
                    addressIndex={addressIndex}
                />
            );
        }

        return <AutoAddress {...fieldProps} {...this.props} />;
    };

    render() {
        // @ts-expect-error
        return <Field component={this.renderAddressField} {...this.props} />;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AddressQuestion);
